export const MENUS = {
	OPERATIONS_MANAGEMENT: 60
	, SETTINGS: 70
}